export const MAX_OPACITY = 100;
export const MIN_OPACITY = 0;
export const WINDOWS_WITHOUT_OPACITY = [0, 4];
